'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = fetchEntitySagaAuth;

var _effects = require('redux-saga/effects');

var _fetchEntitySaga = require('./fetchEntitySaga');

var _fetchEntitySaga2 = _interopRequireDefault(_fetchEntitySaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchEntitySagaAuth);

/**
 * Reusable fetch Subroutine
 * Implements fetchEntity and verifies the response status code in case of error
 * @param {object} entity - object with the respective actions for a fetch flow: request, success...
 * @param {function} apiFn - method which execute the fetch call
 * @param params - rest of the params and data which are going to be sent to the fetch request
 */

function fetchEntitySagaAuth(entity, apiFn) {
    for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        params[_key - 2] = arguments[_key];
    }

    var result;
    return _regenerator2.default.wrap(function fetchEntitySagaAuth$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(function () {
                        return _fetchEntitySaga2.default.apply(undefined, [entity, apiFn].concat(params));
                    });

                case 3:
                    result = _context.sent;
                    return _context.abrupt('return', result);

                case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](0);

                    // redirect to login page
                    window.location = process.env.LOGOUT_REDIRECT_URL;
                    return _context.abrupt('return', _context.t0);

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 7]]);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/utils/fetchEntitySagaAuth.js
// module id = 154
// module chunks = 0